import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, VoidFunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { ConstructionSiteListItem } from '../ConstructionSiteListItem/ConstructionSiteListItem';

export type ConstructionSiteListProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  constructionSites: Array<ConstructionSite>;
};

export const ConstructionSiteList: VoidFunctionComponent<ConstructionSiteListProps> =
  React.memo((props) => {
    const { constructionSites, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <div {...remainingProps}>
        {constructionSites.map((constructionSite) => (
          <ConstructionSiteListItem
            key={EntityUtils.getTrackingKey(constructionSite)}
            constructionSite={constructionSite}
            data-testid="ConstructionSiteList.ConstructionSiteListItem"
          ></ConstructionSiteListItem>
        ))}
      </div>
    );
  });
